import React, { useEffect } from "react";
import PageLayout from "../../../components/PageLayout";
import { useDispatch } from "react-redux";
import withRouter from "../../../components/Common/withRouter";
import { resetApplicationResponseMsg } from "../../../store/menu/application/actions";
import AddApp from "../home/AddApp";





const Application = (props) => {
    const pageName = "Application"
    const dispatch = useDispatch();





    const breadcrumbItems = [
        { text: "Home", link: "/" },
        { text: pageName, link: "/application" },

    ];


    return (
        <React.Fragment>
            <PageLayout pageName={pageName} breadcrumbItems={breadcrumbItems} >
                <AddApp />
            </PageLayout>
        </React.Fragment >
    );
};
export default withRouter(Application);